<template>
<v-row wrap>
    <!-- <v-dialog v-model="data.loadsync" persistent max-width="290">
    </v-dialog> -->

    <v-overlay :value="data.loadsync" :opacity="0.2">
        <v-progress-circular :size="400" :width="20" color="teal" indeterminate>
            <v-card-text style="font-size:75px">Loading</v-card-text>
        </v-progress-circular>
    </v-overlay>

    <v-dialog v-model="dialog" persistent max-width="600px">
        <v-card v-if="selectuser != null">
            <v-card-title>
                <span class="headline">{{popuptitle}}</span>
            </v-card-title>
            <v-card-text>
                <v-container>
                    <v-row>
                        <v-col cols="12">
                            <v-text-field label="Email*" v-model="email" required></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="6">
                            <v-text-field label="firstname*" v-model="firstname"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="6">
                            <v-text-field label="lastname*" v-model="lastname"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="6">
                            <v-text-field label="phone*" v-model="phone"></v-text-field>
                        </v-col>
                        <!-- <v-col cols="12" sm="6" md="6">
                            <v-text-field label="Timelimit*" v-model="timelimit"></v-text-field>
                        </v-col> -->
                        <v-col cols="12" sm="6" md="6">
                            <!-- <v-text-field label="Timelimit*" v-model="user.type"></v-text-field> -->
                            <v-select :items="typeuser" v-model="usertypr" label="User Type"></v-select>
                        </v-col>

                    </v-row>
                </v-container>
                <small>*indicates required field</small>
            </v-card-text>
            <v-card-actions>
                <v-btn color="red" v-if='!deleteuserbtn && popuptitle != "Add User" ' dark @click="deleteuserbtn = true">
                    DELETE USER
                </v-btn>
                <v-btn color="red" text v-if='deleteuserbtn' dark @click="deleteuserbtn = false">
                    cancel
                </v-btn>
                <v-btn color="red" v-if='deleteuserbtn' dark @click="deleteuser">
                    confirm
                </v-btn>

                <v-btn color="orange" v-if='!resetpasswordbtn && popuptitle != "Add User"' dark @click="resetpasswordbtn = true">
                    Reset Password
                </v-btn>
                <v-btn color="orange" text v-if='resetpasswordbtn' dark @click="resetpasswordbtn = false">
                    cancel
                </v-btn>
                <v-btn color="orange" v-if='resetpasswordbtn' dark @click="resetpassword">
                    confirm
                </v-btn>

                <v-spacer></v-spacer>

                <v-btn color="blue darken-1" text @click="closedialog">
                    Close
                </v-btn>
                <v-btn color="blue darken-1" v-if='!adduserprofile' text @click="updateuser">
                    Save
                </v-btn>
                <v-btn color="blue darken-1" v-if='adduserprofile' text @click="add">
                    Save
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

    <v-col cols="12">
        <v-row justify="center" style="padding-top:5vh">

            <v-col cols="12">
                <!-- <div class="text-start">
                    <v-btn rounded color="success" @click="adduser">
                        <v-icon left>
                            mdi-plus-circle
                        </v-icon>
                        Add user
                    </v-btn>
                </div> -->
                <v-row wrap>
                    <v-col cols="2">
                        <v-btn rounded color="success" @click="adduser">
                            <v-icon left>
                                mdi-plus-circle
                            </v-icon>
                            Add user
                        </v-btn>
                    </v-col>

                    <v-col cols="2">
                        <v-btn rounded color="blue darken-4" class="white--text" @click="syncad">
                            <v-icon left>
                                mdi-autorenew
                            </v-icon>
                            Sync Microsoft Azure AD
                        </v-btn>
                    </v-col>

                </v-row>

            </v-col>
            <v-card>

                <v-card-title v-if="data.showtable" width="100%">
                    <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line hide-details></v-text-field>
                </v-card-title>
                <v-data-table v-if="data.showtable" width="500" :headers="header" :items="data.datatable" :items-per-page="6" :footer-props="{ 'items-per-page-options': [6,9]}" :search="search" class="elevation-1 ">

                    <template v-slot:item.timelimit="{ item }">
                        <v-chip v-if="item.timelimit === '99:99:99'" color="light-green darken-1" dark>
                            Unlimited
                        </v-chip>
                        <v-chip v-if="item.timelimit !== '99:99:99'" color="deep-orange darken-3" dark>
                            {{ item.timelimit }}
                        </v-chip>
                    </template>

                    <template v-slot:item.booking_status="{ item }">
                        <v-chip v-if="item.booking_status === 'booking'" color="light-green darken-1" dark>
                            {{ item.booking_status }}
                        </v-chip>
                        <v-chip v-if="item.booking_status === 'cancel'" color="deep-orange darken-3" dark>
                            {{ item.booking_status }}
                        </v-chip>
                    </template>

                    <template v-slot:item.action="{ item }">
                        <!-- <v-menu > -->
                        <v-btn fab icon small @click="editItem(item)">
                            <v-icon color="light-blue accent-4">
                                mdi-dots-horizontal
                            </v-icon>
                        </v-btn>

                        <!-- </v-menu> -->
                    </template>

                </v-data-table>
            </v-card>
        </v-row>
    </v-col>
</v-row>
</template>

<script>
import {
    Data
} from '../models'
import {
    mapState,
    dispatch,
    mapActions,
    store
} from 'vuex'
export default {
    data() {
        return {

            popuptitle: "",
            adduserprofile: false,
            deleteuserbtn: false,
            resetpasswordbtn: false,
            typeuser: ['admin', 'user', ],
            selectuser: null,
            dialog: false,
            search: '',

            firstname: null,
            lastname: null,
            email: null,
            phone: null,
            timelimit: null,
            usertypr: null,

            dialogtext: null,

            header: [{
                    "text": "Email",
                    "value": "email",
                    width: '120',
                },
                {
                    "text": "Firstname",
                    "value": "firstname",
                    width: '200',
                },
                {
                    "text": "Lastname",
                    "value": "lastname",
                    width: '200',
                },
                {
                    "text": "Phone",
                    "value": "phone",
                    width: '120',
                },
                // {
                //     "text": "Timelimit",
                //     "value": "timelimit",
                //     width: '100',
                //     align: 'center'
                //     // align: 'center'
                // },
                {
                    "text": "Action",
                    "value": "action",
                    width: '100',
                    sortable: false
                }
            ],
        }
    },

    computed: {
        formTitle() {
            return this.editedIndex === -1 ? 'New Item' : 'Edit Item'
        },
        ...mapState('datas', {
            data: 'data'
        }),
    },

    created() {
        // this.$store.dispatch("datas/getbooking")
        this.$store.dispatch("datas/getlistuser")
    },

    methods: {
        editItem(item) {
            this.popuptitle = "Edit User"

            this.selectuser = item
            // console.log(this.selectuser)
            this.adduserprofile = false
            this.dialog = true

            this.firstname = item.firstname
            this.lastname = item.lastname
            this.email = item.email
            this.phone = item.phone
            this.timelimit = item.timelimit
            this.usertypr = item.type
        },
        confirm() {
            let payload = new FormData()
            let status
            if (this.booking.booking_status == "booking") {
                status = "cancel"
            } else if (this.booking.booking_status == "cancel") {
                status = "booking"
            }
            payload.append('booking_id', this.booking.booking_id)
            payload.append('status', status)
            this.$store.dispatch("datas/changebookingstatus", payload)
            // console.log(this.booking)
            this.dialog = false
        },
        updateuser() {
            // console.log(this.user)
            let payload = new FormData()
            payload.append('user_id', this.selectuser.user_id)
            payload.append('firstname', this.firstname)
            payload.append('lastname', this.lastname)
            payload.append('email', this.email)
            payload.append('phone', this.phone)
            payload.append('timelimit', this.timelimit)
            payload.append('type', this.usertypr)
            this.$store.dispatch("datas/updateuser", payload)
            this.dialog = false
            this.selectuser = null
        },
        deleteuser() {
            // console.log("delete")
            let payload = new FormData()
            payload.append('user_id', this.selectuser.user_id)
            this.$store.dispatch("datas/deleteuser", payload)
            this.dialog = false
            this.selectuser = null
            this.deleteuserbtn = false
        },
        adduser() {
            this.popuptitle = "Add User"

            this.selectuser = []

            this.email = null
            this.firstname = null
            this.lastname = null
            this.phone = null
            this.timelimit = null
            this.type = null
            this.usertypr = null

            this.selectuser.email = null
            this.selectuser.firstname = null
            this.selectuser.lastname = null
            this.selectuser.phone = null
            this.selectuser.timelimit = null
            this.selectuser.type = null
            this.dialog = true
            this.adduserprofile = true
        },
        add() {
            this.adduserprofile = false
            let payload = new FormData()
            console.log(this.usertypr)
            payload.append('firstname', this.firstname)
            payload.append('lastname', this.lastname)
            payload.append('email', this.email)
            payload.append('phone', this.phone)
            // payload.append('timelimit', this.timelimit)
            payload.append('type', this.usertypr)

            this.$store.dispatch("datas/adduser", payload)
            this.dialog = false
        },
        syncad(){
           this.$store.dispatch("datas/syncad") 
        },
        closedialog() {
            this.dialog = false
            this.deleteuserbtn = false
            this.resetpasswordbtn = false
        },
        resetpassword() {

            let payload = new FormData()
            payload.append('user_id', this.selectuser.user_id)
            this.$store.dispatch("datas/resetpassword", payload)

            this.dialog = false
            this.selectuser = null
            this.deleteuserbtn = false
            this.resetpasswordbtn = false
        }

    },
}
</script>

<style>

    </style>
